module.exports = __webpack_public_path__ + "static/img/2.587c3f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/2.png
// module id = 2Gx2
// module chunks = 0